import React, { FC } from "react";

import {
  ActionableMessage,
  ActionableMessageProps,
  Button,
} from "../../common";
import { UIStatus } from "../../../types/GlobalTypes";

type Props = {
  text?: string;
} & Omit<
  ActionableMessageProps,
  "heading" | "type" | "icon" | "text" | "ctaContent"
>;

export const GetVerifiedMessage: FC<Props> = ({
  text = "To issue invoices and get payouts",
  ...rest
}) => {
  return (
    <ActionableMessage
      heading="Missing verification"
      text={text}
      type={UIStatus.ERROR}
      ctaContent="Get verified"
      ctaProps={{
        block: false,
        variant: Button.variant.SECONDARY,
      }}
      {...rest}
    />
  );
};
